(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-rebrand"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // The section wrapper (.shopify-section.vm-header) is the element that
      // pins and hides: the sticky/hidden classes only position correctly on
      // an element whose sticky containing block is the whole page.
      this.header = this.closest('.shopify-section') || this;
      // The announcement bar stays pinned above the header, so it hides and
      // reveals in lockstep with it.
      this.announcementBar = document.querySelector('.announcement-bar-new');
      this.headerBounds = {};
      this.currentScrollTop = 80;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const isSearchOpen = document.querySelector('.vm-header__search-container.open');

      if ((this.predictiveSearch && this.predictiveSearch.isOpen) || isSearchOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.announcementBar?.classList.add('vm-announcement-bar--hidden');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.announcementBar?.classList.remove('vm-announcement-bar--hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.announcementBar?.classList.remove('vm-announcement-bar--hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-header"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('lp-header-cta').addEventListener('click', function () {
    document.querySelector(this.getAttribute('scroll-target'))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-product-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('lp_product_benefits', () => ({
      productBenefitsContainer: document.getElementById('lp-product-benefits-container'),
      init() {
        setTimeout(() => {
          this.checkContainerScroll();
        }, 1000);
      },
      checkContainerScroll() {
        const scrollRightBtn = document.getElementById('lp-product-benefit-scroll-right');
        const scrollLeftBtn = document.getElementById('lp-product-benefit-scroll-left');
        const widthDiff = this.productBenefitsContainer.scrollWidth - this.productBenefitsContainer.offsetWidth - 10;
        scrollRightBtn.style.display = this.productBenefitsContainer.scrollLeft < widthDiff ? 'block' : 'none';
        scrollLeftBtn.style.display = this.productBenefitsContainer.scrollLeft > 0 ? 'block' : 'none';
      },
      scrollHorizontal(direction) {
        this.productBenefitsContainer.scrollTo({
          left: this.productBenefitsContainer.scrollLeft + (direction === 'right' ? 200 : -200),
          behavior: 'smooth',
        });
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('lp-anchor-cta').addEventListener('click', function () {
    document.querySelector(this.getAttribute('scroll-target'))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-vm-header');
      this.headerBounds = {};
      this.currentScrollTop = 80;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
